import { getAxios } from '../utils/requests'
const axios = getAxios()

export const getSessionInfo = () => {
  return axios.get('/api/system/session')
}
